import { useRef } from 'react';
import { studioImage } from '@/mocks/home';
import { useMotion, useWordEmphasis } from '@/hooks/useEditorialMotion';
import SplitWords from '@/components/base/SplitWords';

const STATEMENT = 'A daylit space for considered cutting and colour.';

export default function Studio() {
  const ref = useRef<HTMLElement>(null);
  useMotion(ref);
  useWordEmphasis(ref);

  return (
    <section ref={ref} id="studio" className="bg-background-100 py-16 md:py-28">
      <div data-group className="max-w-[1320px] mx-auto px-5 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-10 items-center">
        <div className="lg:col-span-5 lg:pr-8">
          <h2 data-m="words" className="font-heading font-semibold tracking-[-0.02em] leading-[1.05] text-[36px] md:text-[52px] text-foreground-950"><SplitWords text="The Studio" /></h2>
          <p data-emphasis className="mt-6 text-[22px] md:text-[26px] leading-snug font-medium text-foreground-950">
            {STATEMENT.split(' ').map((w, i, arr) => (
              <span key={`${w}-${i}`}><span data-word>{w}</span>{i < arr.length - 1 ? ' ' : ''}</span>
            ))}
          </p>
          <p data-m="text" data-at="0.22" className="mt-5 text-[16px] leading-relaxed text-foreground-700">
            Every appointment begins with a consultation. We plan each cut around how your hair grows, and each colour around your skin tone and routine, so the result still works weeks later.
          </p>
          <div data-m="btn" data-at="0.4" className="mt-8">
            <a href="#gallery" className="link-arrow inline-flex items-center gap-2 text-[14px] font-medium text-foreground-950 border-b border-foreground-950 pb-0.5 whitespace-nowrap cursor-pointer hover:text-foreground-600">
              See our work <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
            </a>
          </div>
        </div>
        <div className="lg:col-span-7 w-full aspect-[4/3] overflow-hidden">
          <img data-m="focus" data-at="0.3" src={studioImage} width={1600} height={1200} loading="lazy" decoding="async" alt="Bright NOVA Hair Studio interior with arched mirrors and oak styling stations" title="NOVA Hair Studio interior" className="w-full h-full object-cover object-center" />
        </div>
      </div>
    </section>
  );
}